import { render, staticRenderFns } from "./MacroDetails.vue?vue&type=template&id=8bcd0386&scoped=true"
import script from "./MacroDetails.vue?vue&type=script&lang=js"
export * from "./MacroDetails.vue?vue&type=script&lang=js"
import style0 from "./MacroDetails.vue?vue&type=style&index=0&id=8bcd0386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd0386",
  null
  
)

export default component.exports